module.exports = __webpack_public_path__ + "img/mainImg_phone.5bb24842.webp";